"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Flyout = void 0;
var react_1 = __importStar(require("react"));
var Popper_1 = require("../Popper");
var Caret_1 = require("../Caret");
var Pane_1 = require("../Pane");
var compose_react_refs_1 = __importDefault(require("@seznam/compose-react-refs"));
var Mode;
(function (Mode) {
    Mode[Mode["Resting"] = 0] = "Resting";
    Mode[Mode["Active"] = 1] = "Active";
})(Mode || (Mode = {}));
exports.Flyout = react_1.default.forwardRef(function (_a, forwardedRef) {
    var label = _a.label, children = _a.children, _b = _a.open, defaultOpen = _b === void 0 ? false : _b, rest = __rest(_a, ["label", "children", "open"]);
    var _c = __read((0, react_1.useState)(defaultOpen ? Mode.Active : Mode.Resting), 2), mode = _c[0], setMode = _c[1];
    var keepAlive = (0, react_1.useRef)(false);
    var mouseEnter = (0, react_1.useRef)(null);
    var mouseLeave = (0, react_1.useRef)(null);
    var handleMouseEnter = function () {
        mouseLeave.current && clearTimeout(mouseLeave.current);
        mouseEnter.current = setTimeout(function () {
            setMode(Mode.Active);
        }, 250);
    };
    var handleMouseLeave = function () {
        mouseEnter.current && clearTimeout(mouseEnter.current);
        mouseLeave.current = setTimeout(function () {
            if (keepAlive.current)
                return;
            setMode(Mode.Resting);
        }, 250);
    };
    var handlePaneMouseEnter = function () {
        keepAlive.current = true;
    };
    var handlePaneMouseLeave = function () {
        keepAlive.current = false;
        setMode(Mode.Resting);
    };
    var handleClick = function () {
        // If flyout happens to be open a click will register as a click outside.
        // In this case use setImmediate to wait for that to execute,
        // then immediately re-open.
        setImmediate(function () {
            setMode(Mode.Active);
        });
    };
    var handleClose = function () {
        setMode(Mode.Resting);
    };
    var _d = (0, Popper_1.usePopper)({
        open: mode === Mode.Active,
        onClose: handleClose,
        placement: "right-end",
        distance: 0,
        modifiers: [
            {
                name: "preventOverflow",
                options: {
                    altAxis: true,
                },
            },
        ],
    }), anchorRef = _d.anchorRef, childrenRef = _d.childrenRef, open = _d.open;
    var handleKeydown = (0, react_1.useCallback)(function (_a) {
        var key = _a.key;
        switch (key) {
            case "Escape":
                setMode(Mode.Resting);
                break;
            default:
                break;
        }
    }, []);
    var handleElementKeydown = (0, react_1.useCallback)(function (_a) {
        var _b;
        var key = _a.key;
        switch (key) {
            case "ArrowRight":
                (_b = anchorRef.current) === null || _b === void 0 ? void 0 : _b.click();
                break;
            default:
                break;
        }
    }, [anchorRef]);
    (0, react_1.useEffect)(function () {
        window.addEventListener("keydown", handleKeydown);
        var element = anchorRef.current;
        element === null || element === void 0 ? void 0 : element.addEventListener("keydown", handleElementKeydown);
        return function () {
            window.removeEventListener("keydown", handleKeydown);
            element === null || element === void 0 ? void 0 : element.addEventListener("keydown", handleElementKeydown);
        };
    }, [handleKeydown, handleElementKeydown, anchorRef]);
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(Pane_1.PaneOption, __assign({ ref: (0, compose_react_refs_1.default)(forwardedRef, anchorRef), onMouseEnter: handleMouseEnter, onMouseLeave: handleMouseLeave, onClick: handleClick, display: "flex", alignItems: "center", justifyContent: "space-between", width: "100%" }, rest),
            label,
            react_1.default.createElement(Caret_1.Caret, { ml: 3, direction: "right" })),
        open && (react_1.default.createElement(Pane_1.Pane, { ref: childrenRef, zIndex: 1, onMouseEnter: handlePaneMouseEnter, onMouseLeave: handlePaneMouseLeave, onEnter: handleClose }, children))));
});
exports.Flyout.displayName = "Flyout";
//# sourceMappingURL=Flyout.js.map